import { IIndicator, UIErrorHandlingService } from "@gtmhub/error-handling";
import { IComponentOptions, IRootScopeService } from "angular";
import { IWorkdaySettings } from "../../models";
import { WorkdayUserProvisioningService } from "../../workday-user-provisioning-service";

export class ProvisioningCtrl {
  workdaySettings: IWorkdaySettings;
  indicators: {
    loading?: IIndicator;
  };

  static $inject = ["$rootScope", "WorkdayUserProvisioningService", "UIErrorHandlingService"];
  constructor(
    private $rootScope: IRootScopeService,
    private workdayUserProvisioningService: WorkdayUserProvisioningService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {}

  $onInit(): void {
    this.indicators = {};
    this.getWorkdaySettings();
  }

  getWorkdaySettings(): void {
    this.indicators.loading = { progress: true };
    this.workdayUserProvisioningService
      .getWorkdayUserProvisionSettings()
      .then((response) => {
        this.workdaySettings = response;
        delete this.indicators.loading;
      })
      .catch((error) => {
        this.uiErrorHandlingService.handleModal(error);
        delete this.indicators.loading;
      });
  }

  resetIndicator(indicator: keyof ProvisioningCtrl["indicators"]): void {
    delete this.indicators[indicator];
  }

  saveSettings(): void {
    this.$rootScope.$broadcast("saveSettingsClicked");
  }

  runProvisioning(): void {
    this.$rootScope.$broadcast("runProvisioningClicked");
  }
}

export const ProvisioningComponent: IComponentOptions = {
  controller: ProvisioningCtrl,
  templateUrl: require("./provisioning.jade"),
};
